/**
 * Search modal: dynamic --search-offset based on actual header position.
 * Set on :root so dialog (in top layer) reliably inherits it.
 * When Search is triggered from within the menu drawer, close the drawer first.
 */
(function () {
  document.addEventListener('dialog:trigger:search', () => {
    const menuDrawer = document.querySelector('menu-drawer');
    if (menuDrawer?.querySelector('dialog[open]')) {
      document.dispatchEvent(new CustomEvent('dialog:force-close:menu-drawer'));
    }
  }, { capture: true });

  const updateSearchOffset = () => {
    const headerMenu = document.querySelector('header-menu');
    if (!headerMenu) return;

    const rect = headerMenu.getBoundingClientRect();
    const offset = Math.max(0, Math.ceil(rect.bottom) - 1);
    document.documentElement.style.setProperty('--search-offset-js', `${Math.max(0, offset)}px`);
  };

  document.addEventListener('dialog:open:search', () => {
    requestAnimationFrame(() => requestAnimationFrame(updateSearchOffset));
  });

  document.addEventListener('DOMContentLoaded', () => {
    const searchDialog = document.querySelector('custom-dialog[data-name="search"]');
    if (!searchDialog) return;
    const observer = new MutationObserver(() => {
      if (searchDialog.querySelector('dialog[open]')) {
        requestAnimationFrame(() => requestAnimationFrame(updateSearchOffset));
      }
    });
    observer.observe(searchDialog, { attributes: true, subtree: true, attributeFilter: ['open'] });
  });
})();
